module.exports = __webpack_public_path__ + "statics/img/9.30a4338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/9.png
// module id = +hOJ
// module chunks = 1